import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import { IPassengerWallet } from "models/passengerWallet";
import { useWalletAlertContext } from "./AlertContext";
import PlusIcon from "components/Icons/PlusIcon";
import MinusIcon from "components/Icons/MinusIcon";
import ViewIcon from "components/Icons/ViewIcon";
import { isAdmin, isCasherOrSuperAdmin } from "helpers/privilege";

interface IProps {
  wallet: IPassengerWallet;
}

export default function Action({ wallet }: IProps) {
  const { showAdd, showDeduct } = useWalletAlertContext();

  return (
    <div className="flex items-center gap-x-2">
      {isCasherOrSuperAdmin() && (
        <button onClick={() => showAdd(wallet)}>
          <PlusIcon />
        </button>
      )}
      {isAdmin() && (
        <button onClick={() => showDeduct(wallet)}>
          <MinusIcon />
        </button>
      )}
      <Link
        className="rounded-ful hover:text-black"
        to={RouteName.PASSENGER_WALLET_DETAIL.replace(":id", wallet.passenger_id)}
      >
        <ViewIcon />
      </Link>
    </div>
  );
}
